import { Component, HostBinding, Input, OnInit, Inject, OnDestroy } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import icBookmarks from '@iconify/icons-ic/twotone-bookmarks';
import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';
import icPersonAdd from '@iconify/icons-ic/twotone-person-add';
import icAssignmentTurnedIn from '@iconify/icons-ic/twotone-assignment-turned-in';
import icBallot from '@iconify/icons-ic/twotone-ballot';
import icDescription from '@iconify/icons-ic/twotone-description';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { ILang } from 'src/@evo/interfaces/lang.interface';
import plus from '@iconify/icons-fa-solid/plus';
import angle_down from '@iconify/icons-fa-solid/angle-down';
import { LanguageService } from 'src/app/pages/Services/language.service';
import { setSecureItem } from 'src/app/pages/Services/secure-storage';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/catch';

@Component({
  selector: 'nc-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {
  ILang : ILang = <ILang>{};
  ILangList : ILang[] =[];
  @Input() mobileQuery: MediaQueryList;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;

  isHorizontalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'vertical'));

  icBookmarks = icBookmarks;
  icMenu = icMenu;
  icPersonAdd = icPersonAdd;
  icAssignmentTurnedIn = icAssignmentTurnedIn;
  icBallot = icBallot;
  icDescription = icDescription;
  icAssignment = icAssignment;
  icReceipt = icReceipt;
  icDoneAll = icDoneAll;
  lang="";
  plus = plus;
  angle_down = angle_down;
  lang$: Observable<string>;


  constructor(private layoutService: LayoutService,
    
    public languageService: LanguageService,
    private configService: ConfigService,
    private sharedService : SharedService,
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private http: HttpClient) {
       
      this.lang$ = this.languageService.getLanguage();

      // // this.GetAppLanguage(translate);
      // const browserLang = localStorage.getItem('lang');  
      // // translate.use(browserLang); 
      // this.lang = browserLang;

      // if (localStorage.getItem('lang')) { 
      //   if(this.lang=="ar"){
      //       this.router.navigate([], {
      //         queryParams: {
      //           rtl: 'true'
      //         }
      //       }).then(() => {
      //         if (window) {
      //         }
      //       });
      //   }  
      //   else{
      //     this.router.navigate([], {
      //       queryParams: {
      //         rtl: 'false'
      //       }
      //     }).then(() => {
      //       if (window) {
      //       }
      //     });
      //   }
      // } else {  
      //   localStorage.setItem('lang', 'en');  
      //   this.lang ="en";
      //   this.router.navigate([], {
      //     queryParams: {
      //       rtl: 'false'
      //     }
      //   }).then(() => {
      //     if (window) {
      //     }
      //   });
      // }  
    }

  ngOnInit() {
      this.lang$.subscribe(lang => {
        this.translate.use(lang['fileName'])
      });
  }

  GetAppLanguage(translate : TranslateService){
   
    // this.ILangList.push({display: "English",value:"en", emojione:emojioneUS});
    // translate.addLangs(['en']);
    
    // this.ILangList.push({display: "Arabic",value:"ar", emojione:emojioneLB});
    // translate.addLangs(['ar']);

    // this.ILangList.push({display: "French",value:"fr", emojione:emojioneFR});
    // translate.addLangs(['fr']);

    // this.ILangList.push({display: "Greek",value:"el", emojione:emojioneEL});
    // translate.addLangs(['el']);
  }
  
  openQuickpanel() {
    this.layoutService.openQuickpanel();
  }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  ApplicationDirection(){
    if(this.lang=="ar")
      this.layoutService.enableRTL();
    else  this.layoutService.disableRTL();
   }
   changeLang(language: string) {
     var oldLang = this.lang;
     if(oldLang !=language ){
       localStorage.setItem('lang', language);  
      //  this.translate.use(language); 
       this.lang = language; 
       this.ApplicationDirection();
     }
   }

   changeLanguage(lang) {
    this.sharedService.getConfig().subscribe(
      (confiObj) => {
        let fileName  = confiObj['MODULE_ID']+"_"+lang.langId+"_"+confiObj['MODULE_NAME']+"_"+lang.description;
        this.http.get<any>("./assets/locale/"+fileName+".json").subscribe(
          data => {
            this.languageService.setLanguage(lang);
            this.languageService.selectedLang = lang;
            setSecureItem("selectedLang", JSON.stringify(lang));
            window.location.reload();
          },
          error => {
            //code to handle if file not found
            this.languageService.setLanguage({
              "langId": 1,
              "shDescNbr": null,
              "lgDescNbr": 29946,
              "used": true,
              "validated": true,
              "description": "English",
              "fileName" : "",
              "languagecode": "en"
          });
            this.languageService.selectedLang = {
              "langId": 1,
              "shDescNbr": null,
              "lgDescNbr": 29946,
              "used": true,
              "validated": true,
              "description": "English",
              "fileName" : "",
              "languagecode": "en"
          };
            setSecureItem("selectedLang", JSON.stringify(this.languageService.selectedLang));
            window.location.reload();
          })
        })      
    }

    ngOnDestroy(){
      // this.languageService.selectedLang = {
      //     "langId": 1,
      //     "shDescNbr": null,
      //     "lgDescNbr": 29946,
      //     "used": true,
      //     "validated": true,
      //     "description": "English",
      //     "fileName" : ""
      // };
      // setSecureItem(
      //   "selectedLang",
      //   JSON.stringify(this.languageService.selectedLang)
      // );
  }
}
